import { render, staticRenderFns } from "./ItemSearch.vue?vue&type=template&id=273abab2&"
import script from "./ItemSearch.vue?vue&type=script&lang=js&"
export * from "./ItemSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/benutzer/Desktop/401/Phywe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('273abab2')) {
      api.createRecord('273abab2', component.options)
    } else {
      api.reload('273abab2', component.options)
    }
    module.hot.accept("./ItemSearch.vue?vue&type=template&id=273abab2&", function () {
      api.rerender('273abab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/phywe/ItemSearch.vue"
export default component.exports